<template>
  <v-container fluid class="pa-0">
    <breadcrumbs-banner
      :bannerTitle="$t('header.glaucomaClub')"
    ></breadcrumbs-banner>
    <v-container class="py-lg-16 pa-10 pa-sm-14 px-lg-3" v-if="clubs">
      <v-row>
        <v-col cols="12" lg="6">
          <h3
            class="text-lg-h3 text-h5 text-navy font-weight-bold"
            v-html="clubs[0].name"
          ></h3>
          <p
            class="text-navy font-weight-light text-justify mt-lg-5 mr-lg-10"
            v-html="clubs[0].description"
          ></p>
        </v-col>
        <v-col cols="12" lg="6">
          <v-img
            :src="clubs[0].upload.path"
            class="rounded-lg mt-lg-3"
          ></v-img>
        </v-col>
      </v-row>
      <v-row class="py-lg-10 flex-column-reverse flex-lg-row mt-10 mt-lg-0">
        <v-col cols="12" lg="6">
          <v-img
           :src="clubs[1].upload.path"
            class="rounded-lg mt-lg-3"
          ></v-img>
        </v-col>
        <v-col cols="12" lg="6">
          <h3
            class="text-lg-h3 text-h5 text-navy font-weight-bold ml-lg-10"
             v-html="clubs[1].name"
          ></h3>
          <p
            class="text-navy font-weight-light text-justify mt-lg-5 ml-lg-10"
             v-html="clubs[1].description"
          ></p>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="px-0 background-navy py-0 benefits-background" v-if="clubs">
      <v-container class="px-lg-0 px-10 px-sm-12 py-10 py-lg-0">
        <v-row class="ma-0">
          <v-col cols="12" lg="6" class="d-flex flex-column justify-center pt-lg-10">
            <h3
              class="text-lg-h3 text-h5  text-white font-weight-bold"
              v-html="clubs[2].name"
            ></h3>
            <p
              class="text-white font-weight-light  mt-lg-5"
               v-html="clubs[2].description"
            ></p>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <v-container class="py-lg-16 pa-10 pa-sm-14 px-lg-3" v-if="clubs">
      <v-row>
        <v-col cols="12" lg="12">
          <h3
            class="text-lg-h3 text-h5  text-navy font-weight-bold"
            v-html="clubs[3].name"
          ></h3>
          <p
            class="text-navy font-weight-light text-justify mt-lg-5 two-paragraph"
          
            v-html="clubs[3].description"
          ></p>
        </v-col>
      </v-row>
    </v-container>
    <advertising-banner
      v-if="clubs"
      :title="clubs[4].name"
      :message="clubs[4].description"
    ></advertising-banner>
  </v-container>
</template>
<script>
import advertisingBanner from "../../components/advertisingBanner.vue";
import AboutUsService from "@/services/aboutUs";

export default {
  name: "glaucomaClub",
  components: {
    advertisingBanner,
  },
  data(){
    return {
      clubs: null 
    }
  },
  async created() {
      this.clubs = await AboutUsService.getGlaucomaClub();
  }
};
</script>